/* import __COLOCATED_TEMPLATE__ from './eisa-scoring-race-detail.hbs'; */
import Component from '@glimmer/component';

const pointsEISA = [50, 47, 44, 41, 39, 37, 35, 33, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

export default class EisaScoringRaceDetailComponent extends Component
{
	get teams()
	{
		return this.args.config?.teams || [];
	}

	get scoringTeams()
	{
		return this.args.config?.scoringTeams || [];
	}

	get race()
	{
		const races = this.args.config?.nordic?.races || [];
		return races[this.args.raceIndex];
	}

	get scoredResults()
	{
		if (!this.race) return [];

		const allResults = this.args.results?.[this.race.resultsFile] || [];
		const classResults = allResults.filter(r => r.ClassGroupId == this.race.classGroupId);

		// Filter to all EISA teams with OK status, sorted by original place
		const eisaResults = classResults.filter(r =>
			this.teams.includes(r.club) && r.status == 'OK'
		).sort((a, b) => a.place - b.place);

		// Assign EISA place
		eisaResults.forEach((r, i) => r.eisaPlace = i + 1);

		// Handle ties - group by ORIGINAL place, average points based on EISA positions
		let i = 0;
		while (i < eisaResults.length)
		{
			let j = i;
			while (j < eisaResults.length && eisaResults[j].place === eisaResults[i].place)
			{
				j++;
			}
			const tiedCount = j - i;
			let totalPoints = 0;
			for (let k = i; k < j; k++)
			{
				totalPoints += pointsEISA[k] || 0;
			}
			const avgPoints = totalPoints / tiedCount;
			for (let k = i; k < j; k++)
			{
				if (this.scoringTeams.includes(eisaResults[k].club))
				{
					eisaResults[k].eisaPoints = avgPoints;
				}
				else
				{
					eisaResults[k].eisaPoints = 0;
				}
			}
			i = j;
		}

		return eisaResults;
	}
}
